$('.field, select').on('change', function () {
  const $this = $(this)
  if ($this.val() !== '') {
    $this.addClass('entered')
  } else {
    $this.removeClass('entered')
  }
})
